module.exports = __webpack_public_path__ + "static/img/casino.da877dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/casino.png
// module id = FhTd
// module chunks = 1